module.exports = __webpack_public_path__ + "static/media/wea2.42c25a6d.jpg";